(()=>{
  if(customElements.get('herbora-cart-addon'))return;
  const route=()=>window.Shopify?.routes?.root||'/';
  const parse=value=>{try{return JSON.parse(value||'null')}catch(_){return null}};
  const metadata=line=>parse(line?.properties?.__kaching_bundles);
  const requests=new Map();
  async function json(url,options){const response=await fetch(url,options);const body=await response.json();if(!response.ok)throw new Error(body.description||'No se pudo actualizar el carrito. Intentá de nuevo.');return body;}
  function configs(doc){return [...doc.querySelectorAll('script.kaching-bundles-deal-block-settings')].map(el=>parse(el.textContent)).filter(Boolean);}
  async function offerConfig(parent,url){
    const meta=metadata(parent),matches=c=>(c.nanoId||c.id)===meta?.deal&&c.versionId===meta.v;
    const local=configs(document).find(matches);if(local)return local;
    const key=url+'?view=herbora-pdp-base';
    if(!requests.has(key))requests.set(key,fetch(key).then(r=>{if(!r.ok)throw new Error('Oferta no disponible');return r.text()}).then(html=>configs(new DOMParser().parseFromString(html,'text/html'))).catch(e=>{requests.delete(key);throw e}));
    return (await requests.get(key)).find(matches);
  }
  class HerboraCartAddon extends HTMLElement{
    connectedCallback(){
      if(this.bound)return;this.bound=true;this.controller=new AbortController();
      this.button=this.querySelector('button');this.status=this.querySelector('[role=status]');
      this.button.addEventListener('click',()=>this.toggle(),{signal:this.controller.signal});
      this.button.disabled=true;this.load().catch(()=>{this.hidden=true}).finally(()=>{if(this.isConnected)this.button.disabled=false;});
    }
    disconnectedCallback(){this.controller?.abort();this.bound=false;}
    async read(){
      const cart=await json(route()+'cart.js'),parent=cart.items.find(i=>i.key===this.dataset.parentKey&&i.properties?._herbora_cart_upsell==='1')||cart.items.find(i=>{const m=metadata(i);return i.properties?._herbora_cart_upsell==='1'&&this.state?.meta&&m?.id===this.state.meta.id&&m.deal===this.state.meta.deal});
      if(!parent)return null;
      const meta=metadata(parent);if(!meta?.main||!meta.id)return null;
      const config=await offerConfig(parent,this.dataset.parentUrl);if(!config)return null;
      const bar=config.dealBars.find(b=>b.id===(meta.bid||meta.bar));
      // Only use the offer the merchant already configured, never a display-only discount.
      const offer=bar?.upsells?.find(u=>u.productGID==='gid://shopify/Product/'+this.dataset.productId&&u.quantity===1&&u.discountType==='specific');
      if(!offer||offer.variantGIDs?.length&&!offer.variantGIDs.includes('gid://shopify/ProductVariant/'+this.dataset.variantId))return null;
      const existing=cart.items.find(i=>{const m=metadata(i);return String(i.variant_id)===this.dataset.variantId&&m?.id===meta.id&&m.deal===meta.deal&&m.upsell===offer.id});
      return {cart,parent,meta,offer,existing};
    }
    async load(){
      const request=(this.loadRequest||0)+1;this.loadRequest=request;const state=await this.read();if(!this.isConnected||request!==this.loadRequest)return;
      if(!state){this.hidden=true;return;}
      this.state=state;
      const price=state.existing?state.existing.final_price:Math.round(Number(state.offer.discountValue)*100);
      // The existing app offer is in the shop currency. Do not quote it in another market's currency.
      if(state.cart.currency!=='ARS'||!Number.isFinite(price)||price<=0){this.hidden=true;return;}
      const money=n=>new Intl.NumberFormat('es-AR',{style:'currency',currency:state.cart.currency,maximumFractionDigits:0,minimumFractionDigits:0}).format(n/100);
      this.querySelector('[data-hb-ca-price]').textContent=money(price);
      const old=this.querySelector('[data-hb-ca-old]'),regular=Number(this.dataset.regularPrice);old.textContent=regular>price?money(regular):'';
      this.button.setAttribute('aria-checked',String(!!state.existing));
      this.hidden=false;
      // Keep the real cart line and its native index. The active offer card is its visible control.
      const drawer=this.closest('cart-drawer');
      
      if(state.existing){
        [...drawer.querySelectorAll('[data-hb-line-key]')].find(row=>row.dataset.hbLineKey===state.existing.key)?.setAttribute('data-hb-addon-card-row','');
      }
    }
    async refresh(result,keepClosed=false){
      const drawer=this.closest('cart-drawer');
      if(!result.sections?.['cart-drawer']){
        const sections=await json(route()+'?sections=cart-drawer,cart-icon-bubble');result={...result,sections};
      }
      // Prepare the entire next card before replacing the live drawer. No intermediate duplicate row.
      const doc=new DOMParser().parseFromString(result.sections['cart-drawer'],'text/html');
      const next=doc.querySelector('herbora-cart-addon');
      const fresh=await this.read();
      if(next&&fresh){
        const money=n=>new Intl.NumberFormat('es-AR',{style:'currency',currency:fresh.cart.currency,maximumFractionDigits:0,minimumFractionDigits:0}).format(n/100);
        next.dataset.parentKey=fresh.parent.key;
        next.querySelector('button').setAttribute('aria-checked',String(!!fresh.existing));
        const price=fresh.existing?fresh.existing.final_price:Math.round(Number(fresh.offer.discountValue)*100);
        next.querySelector('[data-hb-ca-price]').textContent=money(price);
        const regular=Number(next.dataset.regularPrice);next.querySelector('[data-hb-ca-old]').textContent=regular>price?money(regular):'';
        next.hidden=false;
        if(fresh.existing)[...doc.querySelectorAll('[data-hb-line-key]')].find(row=>row.dataset.hbLineKey===fresh.existing.key)?.setAttribute('data-hb-addon-card-row','');
      }
      result.sections['cart-drawer']=doc.body.innerHTML;
      const scrollTop=drawer.querySelector('.cart-drawer__body')?.scrollTop||0;
      const restoreFocus=document.activeElement===this.button;
      drawer.renderContents(result,keepClosed);
      requestAnimationFrame(()=>{
        const body=drawer.querySelector('.cart-drawer__body');if(body)body.scrollTop=scrollTop;
        if(restoreFocus)drawer.querySelector('herbora-cart-addon button')?.focus({preventScroll:true});
      });
    }
    async toggle(){
      if(this.busy)return;
      const previousChecked=this.button.getAttribute('aria-checked');
      this.busy=true;this.button.disabled=true;this.setAttribute('aria-busy','true');this.status.textContent='';
      this.button.setAttribute('aria-checked',String(previousChecked!=='true'));
      let changed=false;
      try{
        const state=await this.read();if(!state)throw new Error('El pack cambió. Cerrá y abrí el carrito para actualizar la oferta.');
        const common={sections:['cart-drawer','cart-icon-bubble'],sections_url:location.pathname};
        let endpoint,payload;
        if(state.existing){
          endpoint='cart/change.js';payload={...common,line:state.cart.items.findIndex(i=>i.key===state.existing.key)+1,quantity:0};
        }else{
          const m=state.meta,props={id:m.id,deal:m.deal,v:m.v,upsell:state.offer.id};
          if(m.abid)props.abid=m.abid;if(m.ab)props.ab=m.ab;
          endpoint='cart/add.js';payload={...common,items:[{id:Number(this.dataset.variantId),quantity:1,parent_line_key:state.parent.key,properties:{__kaching_bundles:JSON.stringify(props)}}]};
        }
        const result=await json(route()+endpoint,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(payload)});changed=true;
        await this.refresh(result);
      }catch(error){
        if(this.isConnected){this.button.setAttribute('aria-checked',previousChecked);await this.load().catch(()=>{});this.status.textContent=changed?'El carrito se actualizó. Cerralo y abrilo para ver el total.':error.message;}
      }finally{this.busy=false;if(this.isConnected){this.removeAttribute('aria-busy');this.button.disabled=false;}}
    }
  }
  customElements.define('herbora-cart-addon',HerboraCartAddon);
})();
/* Keep the native cart requests and prices; reconcile only its rendered HTML. */
(()=>{
  const html=Object.getOwnPropertyDescriptor(Element.prototype,'innerHTML');
  const identity=n=>n.nodeType!==1?n.nodeType:n.hasAttribute('data-hb-line-key')?'line:'+n.dataset.hbLineKey.split(':')[0]+':'+n.id:n.id||n.nodeName;
  function patch(current,next){
    if(current.nodeType!==1){if(current.nodeValue!==next.nodeValue)current.nodeValue=next.nodeValue;return;}
    // This component owns its asynchronous state and event listeners.
    if(current.matches('herbora-cart-addon')){
      for(const a of next.attributes)if(a.name.startsWith('data-'))current.setAttribute(a.name,a.value);
      if(!current.busy)current.load?.().catch(()=>{});
      return;
    }
    for(const a of [...current.attributes])if(a.name!=='data-hb-addon-card-row'&&!next.hasAttribute(a.name))current.removeAttribute(a.name);
    for(const a of next.attributes)if(current.getAttribute(a.name)!==a.value)current.setAttribute(a.name,a.value);
    if(current instanceof HTMLInputElement){current.value=next.value;current.checked=next.checked;}
    children(current,next);
  }
  function children(current,next){
    let cursor=current.firstChild;
    for(const desired of [...next.childNodes]){
      let match=cursor;
      while(match&&(match.nodeName!==desired.nodeName||identity(match)!==identity(desired)))match=match.nextSibling;
      if(match){if(match!==cursor)current.insertBefore(match,cursor);patch(match,desired);cursor=match.nextSibling;}
      else current.insertBefore(desired.cloneNode(true),cursor);
    }
    while(cursor){const old=cursor;cursor=cursor.nextSibling;old.remove();}
  }
  function bind(){
    document.querySelectorAll('cart-drawer #CartDrawer, cart-drawer .drawer__inner').forEach(el=>{
      if(Object.hasOwn(el,'innerHTML'))return;
      Object.defineProperty(el,'innerHTML',{configurable:true,get(){return html.get.call(this)},set(value){
        const template=document.createElement('template');html.set.call(template,value);
        children(this,template.content);bind();
      }});
    });
  }
  bind();new MutationObserver(bind).observe(document.documentElement,{childList:true,subtree:true});
})();

/* The drawer must refresh its own section, not inherit the full cart page refresh. */
customElements.whenDefined('cart-drawer-items').then(()=>{
  const prototype=customElements.get('cart-drawer-items').prototype;
  prototype.onCartUpdate=async function(){
    const drawer=this.closest('cart-drawer');if(!drawer)return;
    const revision=(drawer.hbRefreshRevision||0)+1;drawer.hbRefreshRevision=revision;
    try{
      const root=window.Shopify?.routes?.root||'/';
      const response=await fetch(root+'?sections=cart-drawer,cart-icon-bubble',{headers:{Accept:'application/json'}});
      if(!response.ok)throw new Error('No se pudo actualizar el carrito');
      const sections=await response.json();
      if(!this.isConnected||revision!==drawer.hbRefreshRevision)return;
      if(!sections['cart-drawer'])throw new Error('No se recibió el carrito');
      const addon=drawer.querySelector('herbora-cart-addon');
      if(addon)await addon.refresh({sections},true);
      else drawer.renderContents({sections},true);
    }catch(error){console.warn('Herbora: no se pudo refrescar el carrito',error);}
  };
});


